// Addresses that get no marketing email. Support can remove one (the person
// asked to receive them again); transactional email is never affected.
import React, {useCallback, useEffect, useState} from 'react';
import {
  Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Table, TableBody,
  TableCell, TableHead, TableRow, Typography
} from '@mui/material';

import {listOptOuts, removeOptOut} from '../../actions/notifications';
import {errorMessage, formatTime, PAGE_SIZE} from '../../lib/notifications';

const OptOutsTab = () => {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [toRemove, setToRemove] = useState(null);

  const load = useCallback(async (p) => {
    setLoading(true);
    setError('');
    try {
      const res = await listOptOuts(PAGE_SIZE, p * PAGE_SIZE);
      setRows(res.optOuts || []);
    } catch (e) {
      setError(errorMessage(e));
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(page); }, [load, page]);

  const confirmRemove = async () => {
    const email = toRemove;
    setToRemove(null);
    try {
      await removeOptOut(email);
      load(page);
    } catch (e) {
      setError(errorMessage(e));
    }
  };

  return (
    <>
      {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
      {loading && <CircularProgress size={24} />}
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Org</TableCell>
            <TableCell>Since</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.email}>
              <TableCell>{r.email}</TableCell>
              <TableCell>{r.reason}</TableCell>
              <TableCell>{r.tenantId}</TableCell>
              <TableCell>{formatTime(r.createdAt)}</TableCell>
              <TableCell><Button size="small" color="error" onClick={() => setToRemove(r.email)}>Remove</Button></TableCell>
            </TableRow>
          ))}
          {!loading && rows.length === 0 && <TableRow><TableCell colSpan={5}>No opt-outs.</TableCell></TableRow>}
        </TableBody>
      </Table>
      <Stack direction="row" spacing={1} sx={{mt: 1}}>
        <Button disabled={page === 0 || loading} onClick={() => setPage(page - 1)}>Previous</Button>
        <Button disabled={rows.length < PAGE_SIZE || loading} onClick={() => setPage(page + 1)}>Next</Button>
      </Stack>
      <Dialog open={!!toRemove} onClose={() => setToRemove(null)}>
        <DialogTitle>Remove opt-out?</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            {toRemove} will receive reminder and offer emails again. Only do this when the person asked for it.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setToRemove(null)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={confirmRemove}>Remove</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OptOutsTab;
